export const ENCRYPTION_KEY = 'APP_99288'